export default __webpack_public_path__ + "static/media/careForMom.fef28edc.png";